import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=5c36000f&scoped=true&"
import script from "./Checkout.vue?vue&type=script&lang=js&"
export * from "./Checkout.vue?vue&type=script&lang=js&"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=5c36000f&prod&lang=scss&scoped=true&"
import style1 from "./Checkout.vue?vue&type=style&index=1&id=5c36000f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36000f",
  null
  
)

export default component.exports